import API from "@/global/request/api";
import axios from "@/global/request/axios";

export default {
  login(params) {
    return axios.post(API.login, params);
  },
  studentWork(params) {
    return axios.get(API.myStudentWork, params);
  },
  studentWorkCreate(params) {
    return axios.post(API.myStudentWork, params);
  },
  studentWorkDetail(id) {
    return axios.get(API.myStudentWorkId(id));
  },
  studentWorkDelete(id) {
    return axios.delete(API.myStudentWorkId(id));
  },
  studentWorkEdit(id, params) {
    return axios.put(API.myStudentWorkId(id), params);
  },
  setPassword(params) {
    return axios.put(API.setPwd, params);
  },
  gradeAll(params) {
    return axios.post(API.gradeAll, params);
  },
  getSeasonAll(params) {
    return axios.post(API.seasonAll, params);
  },
  getSchoolAll(params) {
    return axios.post(API.schoolAll, params);
  },
  uploadImage(params, name) {
    return axios.post(API.uploadImage(name), params);
  },
  uploadImageUrl(data) {
    return axios.post(API.uploadImageUrl, data);
  },
  worksSubmit(type, params) {
    return axios.post(API.worksSubmit(type), params);
  },
  userDataType(type, params) {
    return axios.post(API.userDataType(type), params);
  },
  userInfo(params) {
    return axios.get(API.userInfo, params);
  },
  userInfoEdit(params) {
    return axios.put(API.userInfo, params);
  },
  getFeedback(params) {
    return axios.post(API.getFeedback, params);
  },
  classList() {
    return axios.get(API.class);
  },
  classCreate(params) {
    return axios.post(API.classCreate, params);
  },
  classEdit(id, params) {
    return axios.put(API.classId(id), params);
  },
  classDelete(id) {
    return axios.delete(API.classId(id));
  },
  coursewareSubList(params) {
    return axios.get(API.coursewareSub, params);
  },
  coursewareSubDetail(id) {
    return axios.get(API.coursewareSubId(id));
  },
  coursewareFeedBack(params) {
    return axios.get(API.coursewareFeb, params);
  },
  coursewareFeedBackCreate(params) {
    return axios.post(API.coursewareFeb, params);
  },
  coursewareFeedBackDetail(id) {
    return axios.get(API.coursewareFebId(id));
  },
  coursewareFeedBackEdit(id, params) {
    return axios.put(API.coursewareFebId(id), params);
  },
  coursewareFeedBackDelete(id) {
    return axios.delete(API.coursewareFebId(id));
  }
};
